export const HOME = "/";
